export const HOME = "/";
